import { css } from "@emotion/react"
import { useEffect, useRef } from "react"

interface AutoSizeTextInputProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

export default function AutoSizeTextInput(props: AutoSizeTextInputProps) {
  const ref = useRef<HTMLTextAreaElement>(null)

  const onInput = (e: React.InputEvent<HTMLTextAreaElement>) => {
    if (props.onInput) {
      props.onInput(e)
    }

    adjustHeight()
  }

  const adjustHeight = () => {
    const textarea = ref.current
    if (!textarea) return

    textarea.style.height = "auto"
    textarea.style.height = `${textarea.scrollHeight}px`
  }

  // resize on value change (initial + parent update)
  useEffect(() => {
    adjustHeight()
  }, [props.value])

  return (
    <textarea
      {...props}
      onInput={onInput}
      ref={ref}
      rows={1}
      css={css`
        min-height: 40px; // match input height
        padding-block: 0.5rem;
        resize: none;
        overflow: hidden;
      `}
    ></textarea>
  )
}
